<iq-central-front-end-navbar></iq-central-front-end-navbar>
<section class="container my-5 d-body">
  <div>
    <div class="container assign-course">
      <div class="row assign-nav">
        <div class="col-lg-1 col-sm-12"></div>
        <div class="col-lg-10 col-sm-12">
          <ul class="nav nav-pills mb-3 justify-content-center mt-5">
            <li class="nav- click">
              <a class="nav-link " routerLink="/assignCourse/selectCourse">
                <span class="number">1</span> Select Participants</a
              >
            </li>
            <li class="nav-item click">
              <a class="nav-link " routerLink="/assignCourse/selectParticipant">
                <span class="number">2</span> Select Courses</a
              >
            </li>
            <li class="nav-item click">
              <a class="nav-link " routerLink="/assignCourse/chooseDate"
                ><span class="number">3</span>Choose Due Date</a
              >
            </li>
            <li class="nav-item click">
              <a class="nav-link active" routerLink="/assignCourse/Confirmation"
                ><span class="number">4</span>confirmation</a
              >
            </li>
          </ul>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-3 col-sm-12">
          <p class="font-light font18 mt-4 p">
            Select assign more to assign more courses to participants or select
            finish to go back to dashboard.
          </p>
        </div>
        <div class="col-lg-9 col-sm-12 sm-mt">
          <div class="bg-white px-4 pb-3 text-center">
            <div class="row">
              <div class="col-12">
                <img
                  src="assets/images/Confirmation.svg"
                  alt=""
                  class="w-100"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-lg-2 col-sm-12"></div>
              <div class="col-lg-8 col-sm-12">
                <p class="font-light font18 mt-5">
                  You have successfully assigned courses to the selected
                  participants and they have been notified by email.
                </p>
              </div>
            </div>
            <div class="my-5 d-flex justify-content-end">
              <button class="btn btn-secondary mr-2" (click)="add()">
                Assign More
              </button>
              <button class="btn btn-secondary" (click)="finish()">
                Finish
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="mt-auto">
    <hr />
    <iq-central-front-end-footer></iq-central-front-end-footer>
  </div>
</section>
